import { createContext, ReactNode, useContext, useState } from 'react'
import { FirstAvailability } from '../../types'

interface Props {
  children: ReactNode
}

const hookName = 'useFirstAvailability'

type FirstAvailabilityContext = {
  firstAvailability: FirstAvailability | undefined
  setFirstAvailability: (value: FirstAvailability | undefined) => void
}

const context = createContext<FirstAvailabilityContext>({
  firstAvailability: undefined,
  setFirstAvailability: () => undefined,
})

const { Provider } = context

const useFirstAvailability = () => useContext(context)

const FirstAvailabilityProvider = ({ children }: Props) => {
  const [firstAvailability, setFirstAvailability] = useState<FirstAvailability | undefined>()
  const contextValue = { firstAvailability, setFirstAvailability }

  return <Provider value={contextValue}>{children}</Provider>
}

export { FirstAvailabilityProvider, hookName as useFirstAvailabilityHookName, useFirstAvailability }
